<script>
    import keyManagerCreator from "../plugins/common/input/key-manager-creator";

    export default {
        name: "FormTableBaseKeyHelper",
        props: {},
        data() {
            return {
                inputElement: undefined,
                keyManager: undefined,
            };
        },
        methods: {
            registerInput(el) {
                this.inputElement = el;
                this.keyManager = keyManagerCreator.create(el);
                const obj = this.createEventHandlerObject(this.inputElement);
                this.$emit("on", obj);
            },

            createEventHandlerObject(el) {
                console.warn("You must implement createEventHandlerObject to handle td with event handler");
                return {};
            },
        },

    }
</script>

<style scoped>

</style>